import { Button } from './Button';
import Sprite = PIXI.Sprite;
import { createSprite } from '../../../utils/GameEngine';

export class NoAdsPassButton extends Button {
    constructor(callback: () => any) {
        super('no_ads', callback, null, false, false, 0.5);

        setInterval(() => {
            if (this.visible && this.parent) {
                this.playIdleAnimation();
            }
        }, 5000);
    }

    protected drawLayout(): void {
        this.defaultSkin = createSprite(this.skinTexture, this);
        this.defaultSkin.anchor.set(0.5, 0.5);
        const swirl: Sprite = createSprite('stamina_booster_bg_none');
        swirl.anchor.set(0.5, 0.5);
        swirl.scale.set(3, 3);
        this.addChildAt(swirl, 0);
        TweenLite.to(swirl, 6000, {
            rotation: 1080
        });
        TweenMax.to(swirl, 4, {
            alpha: 0.5,
            yoyo: true,
            repeat: -1
        });
    }

    private playIdleAnimation(): void {
        TweenMax.to(this.scale, 1, {
            x: 0.55,
            y: 0.55,
            yoyo: true,
            ease: Elastic.easeIn,
            repeat: 1
        });
    }
}